export default __webpack_public_path__ + "static/media/gallery_04.81746161.jpg";